import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { delay } from 'lodash';
import classNames from 'classnames';
import { MP_VIDEO_THUMBNAIL_SIZE } from '../../../../../utils/mixPanelEvents';
import Image from '../../components/Image';
import GigReview from '../../GigReview';

class VideoSlide extends PureComponent {

    constructor(props) {
        super(props);

        this.showReview = this.showReview.bind(this);
        this.hideReview = this.hideReview.bind(this);
        this.flashReview = this.flashReview.bind(this);
        this.toggleReview = this.toggleReview.bind(this);
        this.showVideoIframe = this.showVideoIframe.bind(this);
        this.renderVideo = this.renderVideo.bind(this);
        this.renderThumbnail = this.renderThumbnail.bind(this);
        this.reportThumbnailSize = this.reportThumbnailSize.bind(this);

        // Initial state
        this.state = {
            isShowingReview: false,
            showingPlayer: false
        };
    }

    componentWillReceiveProps(nextProps) {
        this.hideReview();
        if (nextProps.isActive && !this.props.isActive) {
            this.flashReview();
        }
        if (!nextProps.isActive && this.props.isActive) {
            this.setState({showingPlayer: false});
        }
    }

    componentDidUpdate() {
        const { showingPlayer } = this.state;
        if (showingPlayer && this.videoNode && this.videoNode.play) {
            this.videoNode.play();
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timerId);
    }

    showReview(autohide) {
        const { slide: { review } } = this.props;
        if (!review) { return; }
        clearTimeout(this.timerId);
        this.setState({isShowingReview: true});
        if (autohide === true) {
            this.timerId = delay(this.hideReview, 4000);
        }
    }

    hideReview() {
        clearTimeout(this.timerId);
        this.setState({isShowingReview: false});
    }

    flashReview() {
        this.hideReview();
        this.timerId = delay(this.showReview, 200, true);
    }

    toggleReview() {
        if (this.state.isShowingReview) {
            this.hideReview();
        } else {
            this.showReview();
        }
    }

    showVideoIframe(e) {
        e && e.preventDefault();
        this.setState({showingPlayer: true});
    }

    renderVideo() {
        const { slide: { videoSrc, media }, expanded } = this.props;
        const poster = expanded ? media.original : media.medium;

        return (
            <video src={videoSrc} poster={poster} onClick={this.toggleReview} controls={true}
                ref={(node) => this.videoNode = node} controlsList="nodownload"/>
        );
    }

    reportThumbnailSize({ width, height }) {
        const { biEvents } = this.context;
        if (width <= 300 || height <= 300){
            biEvents.sendMixPanelEvent({
                eventName: MP_VIDEO_THUMBNAIL_SIZE,
                params: {
                    width,
                    height
                }
            });
        }
    }

    renderThumbnail() {
        const { slide: { name, media }, isActive, expanded, preload } = this.props,
            lazyLoad = !isActive && !preload;

        return (
            <figure className="thumbnail" onClick={this.toggleReview}>
                <a href="#" className="fa fa-play slide-play-button"
                    onClick={this.showVideoIframe} rel="nofollow" itemProp="url"/>
                <Image lazyLoad={lazyLoad} isActive={isActive} alt={name}
                    onDimensions={this.reportThumbnailSize}
                    src={expanded ? media.original : media.medium}/>
            </figure>
        );
    }

    render() {
        const { showingPlayer, isShowingReview } = this.state,
            {slide: { review }, onClick, isActive, expanded } = this.props,
            slideClasses = classNames('slide', 'slide-video', {'active-review': isShowingReview && isActive}),
            showReview = expanded ? review : review && !showingPlayer;

        return (
            <div className={slideClasses} onClick={onClick}>
                { this.renderThumbnail() }
                { showingPlayer && this.renderVideo() }
                { showReview && <GigReview {...review} compact={!expanded}/> }
            </div>
        );
    }
}

VideoSlide.propTypes = {
    slide: PropTypes.object.isRequired,
    isActive: PropTypes.bool.isRequired,
    expanded: PropTypes.bool,
    onClick: PropTypes.func,
    preload: PropTypes.bool
};

VideoSlide.contextTypes = {
    biEvents: PropTypes.object
};

export default VideoSlide;
